/* THAYA · product.js — PDP interactions (gallery, variants, fit mode, delivery, modals) */
(function () {
  var pdp = document.querySelector('[data-pdp]');
  if (!pdp) return;

  var form = document.getElementById('thayaProductForm');
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-product-json]').textContent); } catch (e) {}
  var moneyFormat = '${{amount}}';
  try { moneyFormat = JSON.parse(document.querySelector('[data-money-format]').textContent); } catch (e) {}

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, v).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }

  /* ---------- gallery ---------- */
  var mainImg = document.getElementById('thayaMainImg');
  var stage = document.getElementById('thayaStage');
  var thumbs = pdp.querySelectorAll('#thayaThumbs button');
  thumbs.forEach(function (b) {
    b.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      if (!mainImg) return;
      var src = b.getAttribute('data-full');
      if (!src) { var im = b.querySelector('img'); src = im ? im.src : ''; }
      mainImg.style.opacity = 0;
      setTimeout(function () {
        mainImg.removeAttribute('srcset'); // srcset would otherwise override src
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        mainImg.style.opacity = 1;
      }, 150);
    });
  });
  /* ---------- photo viewer ----------
     Pressing the gallery used to scale the image 1.9x into the click point, so the
     shopper got a tighter crop of an already-cropped frame and never saw the garment.
     Now it opens the real photo at full size, object-fit:contain, with nothing cut off. */
  var lb = document.getElementById('thayaLightbox');
  if (stage && mainImg && lb) {
    var lbImg = lb.querySelector('[data-lb-img]');
    var lbCount = lb.querySelector('[data-lb-count]');
    var lbDots = lb.querySelector('[data-lb-dots]');
    var lbPrev = lb.querySelector('[data-lb-prev]');
    var lbNext = lb.querySelector('[data-lb-next]');
    var lastFocus = null;
    var idx = 0;

    var shots = [];
    try { shots = JSON.parse(document.querySelector('[data-gallery-json]').textContent); } catch (e) {}
    // A product with no media rows still has whatever is painted in the stage.
    if (!shots.length && mainImg.src) {
      var only = mainImg.currentSrc || mainImg.src;
      shots = [{ f: only, alt: mainImg.alt || '' }];
    }

    var rtl = (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
    var many = shots.length > 1;

    if (many) {
      shots.forEach(function (s, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('aria-label', String(i + 1));
        d.addEventListener('click', function () { show(i); });
        lbDots.appendChild(d);
      });
    }
    if (lbPrev) lbPrev.hidden = !many;
    if (lbNext) lbNext.hidden = !many;

    // Fetch a photo in the background so the viewer has nothing to wait for.
    // These are the same URLs the thumbnails advertise, so the browser shares
    // one cache entry with the gallery instead of fetching the photo twice.
    function preload(i) {
      var s = shots[(i + shots.length) % shots.length];
      if (!s) return null;
      if (!s._pre) {
        s._pre = new Image();
        s._pre.src = s.f;
      }
      return s._pre;
    }
    function ready(im) { return !!(im && im.complete && im.naturalWidth); }

    // A frame already decoded on this page, so the viewer never opens onto an empty
    // screen. Only the photo the gallery is currently showing qualifies — it is a
    // big file. The thumbnails are 140px and upscaling one looked cheap.
    function cached(i) {
      var act = pdp.querySelector('#thayaThumbs button.is-active');
      if (mainImg && act && parseInt(act.getAttribute('data-img'), 10) === i) {
        if (mainImg.currentSrc || mainImg.src) return mainImg.currentSrc || mainImg.src;
      }
      return shots[i].f;
    }

    var token = 0;
    var dir = 1; // which way she is travelling, so we can fetch ahead of her thumb
    function show(i) {
      var was = idx;
      idx = (i + shots.length) % shots.length;
      if (idx !== was) {
        var step = idx - was;
        if (step === shots.length - 1) step = -1;      // wrapped backwards
        else if (step === -(shots.length - 1)) step = 1; // wrapped forwards
        dir = step > 0 ? 1 : -1;
      }
      var s = shots[idx];
      var mine = ++token;
      var pre = preload(idx);
      lbImg.alt = s.alt || '';

      if (ready(pre)) {
        // already in cache: go straight to the full photo, no intermediate frame
        lbImg.src = s.f;
      } else {
        // not there yet: hold a frame this page has already painted, then swap in
        // the full photo the moment it has decoded
        lbImg.src = cached(idx);
        var apply = function () {
          if (mine !== token) return; // she already swiped past this one
          lbImg.src = s.f;
        };
        if (pre.decode) { pre.decode().then(apply).catch(apply); }
        else { pre.onload = apply; }
      }

      if (lbCount) lbCount.textContent = many ? (idx + 1) + ' / ' + shots.length : '';
      if (many) {
        var ds = lbDots.children;
        for (var k = 0; k < ds.length; k++) ds[k].classList.toggle('is-active', k === idx);
        // run two ahead the way she is going, one behind in case she turns round
        preload(idx + dir);
        preload(idx + dir * 2);
        preload(idx - dir);
      }
    }

    function open() {
      // start on whatever she is already looking at, not back at photo 1
      var act = pdp.querySelector('#thayaThumbs button.is-active');
      var start = act ? parseInt(act.getAttribute('data-img'), 10) : 0;
      show(isNaN(start) ? 0 : start);
      swallow = false;
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.documentElement.classList.add('t-lb-open');
      document.body.classList.add('t-lb-open');
      // focus the dialog itself, not the X — a programmatic focus on the button
      // paints a hard focus ring over the photo
      lb.focus();
    }

    function close() {
      lb.hidden = true;
      document.documentElement.classList.remove('t-lb-open');
      document.body.classList.remove('t-lb-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    stage.addEventListener('click', open);
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
    });

    // Start fetching the full-size file the moment she reaches for the photo,
    // so by the time the tap registers it is already on its way.
    function warm() {
      var a = pdp.querySelector('#thayaThumbs button.is-active');
      var i = a ? parseInt(a.getAttribute('data-img'), 10) : 0;
      if (isNaN(i)) i = 0;
      preload(i);
      if (many) preload(i + 1); // she almost always swipes forward first
    }
    stage.addEventListener('touchstart', warm, { passive: true });
    stage.addEventListener('mouseenter', warm);
    // and once the page has gone quiet, so her very first tap is instant too
    if (window.requestIdleCallback) requestIdleCallback(warm, { timeout: 2500 });
    else setTimeout(warm, 1200);
    // picking a thumbnail is a strong hint she is about to open that one
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var i = parseInt(b.getAttribute('data-img'), 10);
        if (!isNaN(i)) preload(i);
      });
    });

    // Getting out must be effortless: the X, Escape, a tap anywhere on the
    // photo or the dark surround, or a swipe. The only exempt targets are the
    // arrows and dots, which exist to move between photos.
    function isControl(el) { return !!(el && el.closest && el.closest('button')); }

    // A swipe is followed by a synthetic click. Swallow exactly that one, and
    // never more than one, so her next real tap is not eaten.
    var swallow = false;
    lb.querySelector('[data-lb-close]').addEventListener('click', close);
    lb.addEventListener('click', function (e) {
      if (isControl(e.target)) return;
      if (swallow) { swallow = false; return; }
      close();
    });
    if (lbPrev) lbPrev.addEventListener('click', function () { show(idx - 1); });
    if (lbNext) lbNext.addEventListener('click', function () { show(idx + 1); });

    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') { close(); return; }
      if (!many) return;
      // in RTL the arrow keys follow the visual direction of the row
      if (e.key === 'ArrowRight') show(rtl ? idx - 1 : idx + 1);
      if (e.key === 'ArrowLeft') show(rtl ? idx + 1 : idx - 1);
    });

    // swipe sideways for the next photo, swipe away to dismiss
    var x0 = null, y0 = null;
    var st = lb.querySelector('[data-lb-stage]');
    st.addEventListener('touchstart', function (e) {
      swallow = false; // a fresh touch, so no stale gesture to suppress
      if (e.touches.length !== 1 || isControl(e.target)) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    st.addEventListener('touchend', function (e) {
      if (x0 === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      var ax = Math.abs(dx), ay = Math.abs(dy);
      x0 = null;
      // a clear vertical flick means "get me out of here"
      if (ay > 90 && ay > ax) { swallow = true; close(); return; }
      if (many && ax > 45 && ax > ay) {
        swallow = true;
        var fwd = dx < 0;
        show(idx + ((rtl ? !fwd : fwd) ? 1 : -1));
        return;
      }
      // anything smaller was a tap; the click handler closes it
    }, { passive: true });
  }

  /* ---------- variant selection ---------- */
  var OPTSEL = '.t-opt__btn, .t-swatch';
  var selected = [];
  // .t-colorgroup shares the .t-opt class for styling but is not a variant option —
  // it links to sibling products, so it must not take a slot in `selected`.
  pdp.querySelectorAll('.t-opt:not(.t-colorgroup)').forEach(function (opt, i) {
    var active = opt.querySelector('.t-opt__btn.is-active, .t-swatch.is-active');
    var first = opt.querySelector(OPTSEL);
    selected[i] = active ? active.dataset.value : (first ? first.dataset.value : null);
    opt.querySelectorAll(OPTSEL).forEach(function (btn) {
      btn.addEventListener('click', function () {
        opt.querySelectorAll(OPTSEL).forEach(function (x) { x.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected[i] = btn.dataset.value;
        var lbl = opt.querySelector('[data-opt-value]');
        if (lbl) lbl.textContent = btn.dataset.value;
        updateVariant();
        // Link size choice to fit mode: "Customizable" -> Made for me, a number -> Standard sizes
        var v = (btn.dataset.value || '').trim().toLowerCase();
        var seg = null;
        if (/custom|مقاس|تفصيل/.test(v)) seg = pdp.querySelector('.t-fitseg button[data-mode="custom"]');
        else if (/^[0-9٠-٩]+$/.test(v)) seg = pdp.querySelector('.t-fitseg button[data-mode="std"]');
        if (seg && !seg.classList.contains('is-active')) seg.click();
      });
    });
  });

  function currentVariant() {
    return variants.find(function (v) {
      return (v.options || []).every(function (o, idx) { return String(o) === String(selected[idx]); });
    });
  }

  function updateVariant() {
    syncFbtSizes();
    var v = currentVariant();
    var idInput = form.querySelector('[data-variant-id]');
    var atc = pdp.querySelector('[data-atc]');
    if (!v) return;
    if (idInput) idInput.value = v.id;
    pdp.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = money(v.price); });
    var cmp = pdp.querySelector('[data-compare]');
    if (cmp) cmp.style.display = (v.compare_at_price > v.price) ? '' : 'none';
    if (atc && atc.dataset.atcTpl) {
      atc.disabled = !v.available;
      atc.textContent = v.available ? atc.dataset.atcTpl.replace('%price%', money(v.price)) : atc.dataset.soldout;
    } else if (atc) {
      atc.disabled = !v.available;
    }
  }

  /* ---------- "Often bought together" size inheritance ----------
     Each ticked companion should follow the size the shopper already picked for
     this piece: abaya 54 -> under-dress 54. The card renders a map of
     size value -> variant id on every checkbox (in-stock only, made-to-measure
     excluded), so the match happens against her current choice, not a default.
     A companion with no size dimension (one-size, colour-only) keeps the
     variant the card rendered — only a real size mismatch blocks it. */
  function fbtMap(cb) {
    try { return JSON.parse(cb.dataset.fbtSizes || '{}'); } catch (e) { return {}; }
  }
  // `selected` holds one value per option; only the size slot can match a key in
  // the map, so testing them all avoids tracking which index is the size.
  function fbtMatch(map) {
    for (var i = 0; i < selected.length; i++) {
      var k = selected[i];
      if (k != null && Object.prototype.hasOwnProperty.call(map, String(k))) return String(k);
    }
    return null;
  }
  function fbtResolve(cb) {
    var map = fbtMap(cb);
    var hit = fbtMatch(map);
    if (hit !== null) return { id: parseInt(map[hit], 10), size: hit, ok: true };
    // Her size genuinely isn't stocked for this companion — don't slip her another one.
    if (cb.dataset.fbtSized === '1') return { id: null, size: null, ok: false };
    // Size dimension couldn't be identified (e.g. an option name we don't recognise).
    // With several variants the rendered default is a guess, and guessing is how the
    // size-52-for-everyone bug happened — fail visibly instead.
    if (parseInt(cb.dataset.fbtVcount, 10) > 1) return { id: null, size: null, ok: false };
    // Genuinely one variant: nothing to get wrong.
    return { id: parseInt(cb.dataset.fbtVariant, 10), size: null, ok: true };
  }
  function syncFbtSizes() {
    pdp.querySelectorAll('[data-fbt-variant]').forEach(function (cb) {
      var r = fbtResolve(cb);
      var row = cb.closest('.t-obt__item');
      var lbl = row ? row.querySelector('[data-fbt-size-label]') : null;
      // Never leave a greyed row unexplained — say why it can't be added.
      if (lbl) lbl.textContent = r.size ? ' · ' + r.size : (r.ok ? '' : ' · ' + (pdp.dataset.fbtNosize || ''));
      if (row) row.classList.toggle('is-unavailable', !r.ok);
      cb.disabled = !r.ok;
      if (!r.ok) cb.checked = false;
    });
  }
  function fbtExtras() {
    return [].slice.call(pdp.querySelectorAll('[data-fbt-variant]'))
      .filter(function (c) { return c.checked && !c.disabled; })
      .map(function (c) { return fbtResolve(c); })
      .filter(function (r) { return r.ok && r.id; })
      .map(function (r) { return { id: r.id, quantity: 1 }; });
  }
  syncFbtSizes();

  /* ---------- fit mode (standard vs made-to-measure) ---------- */
  var atelier = pdp.querySelector('[data-atelier]');
  var propInputs = atelier ? atelier.querySelectorAll('input, textarea') : [];
  // Express wallets (Apple Pay etc.) jump straight to checkout, so they can't carry the
  // measurement step — hide them while the shopper is in made-to-measure mode.
  var dynCheckout = pdp.querySelector('[data-dyncheckout]');
  pdp.querySelectorAll('.t-fitseg button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var custom = btn.dataset.mode === 'custom';
      pdp.querySelectorAll('.t-fitseg button').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
      btn.classList.add('is-active'); btn.setAttribute('aria-selected', 'true');
      if (atelier) atelier.hidden = !custom;
      if (form) form.classList.toggle('is-custom', custom);
      propInputs.forEach(function (inp) { inp.disabled = !custom; });
      if (dynCheckout) dynCheckout.hidden = custom;
    });
  });
  // "Made to your measure" nudge -> opens made-to-measure mode
  var nudge = pdp.querySelector('[data-mode-nudge]');
  if (nudge) nudge.addEventListener('click', function () {
    var cb = pdp.querySelector('.t-fitseg button[data-mode="custom"]');
    if (cb) cb.click();
    if (atelier) atelier.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---------- unit toggle ---------- */
  var unit = 'in';
  pdp.querySelectorAll('.t-unit button').forEach(function (b) {
    b.addEventListener('click', function () {
      var nu = b.dataset.unit; if (nu === unit) return;
      pdp.querySelectorAll('.t-unit button').forEach(function (x) { x.classList.remove('is-active'); });
      b.classList.add('is-active');
      var f = nu === 'cm' ? 2.54 : 1 / 2.54;
      atelier.querySelectorAll('input[type=number]').forEach(function (inp) {
        if (inp.value) inp.value = Math.round(inp.value * f);
        if (inp.placeholder) inp.placeholder = Math.round(inp.placeholder * f);
      });
      pdp.querySelectorAll('.t-unit-lbl').forEach(function (l) { l.textContent = nu; });
      unit = nu;
    });
  });

  /* ---------- qty ---------- */
  var qtyInput = pdp.querySelector('[data-qty-input]');
  pdp.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.qty, 10));
      qtyInput.value = n;
    });
  });

  /* ---------- add to cart ---------- */
  function submitAdd(e) {
    if (e) e.preventDefault();
    // validate custom mode
    var customBtn = pdp.querySelector('.t-fitseg button[data-mode="custom"].is-active');
    if (customBtn) {
      var missing = false;
      atelier.querySelectorAll('input[type=number]').forEach(function (inp) { if (!inp.value) missing = true; });
      if (missing) { window.ThayaToast && window.ThayaToast(pdp.dataset.fillMsg || 'Add your measurements first'); atelier.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    }
    // "Often bought together" — extras the shopper ticked, in her size
    var extras = fbtExtras();

    if (window.ThayaCart) {
      var p = window.ThayaCart.addFromForm(form);
      if (extras.length && p && p.then) {
        p.then(function () {
          var route = (window.THAYA && window.THAYA.routes && window.THAYA.routes.cart_add) || '/cart/add.js';
          return fetch(route, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: extras }) })
            .then(function () { return window.ThayaCart.refresh(); })
            .then(window.ThayaCart.open);
        });
      }
    } else {
      form.submit();
    }
  }
  if (form) form.addEventListener('submit', submitAdd);
  var stickyBtn = document.querySelector('[data-atc-sticky]');
  if (stickyBtn) stickyBtn.addEventListener('click', submitAdd);

  /* ---------- buy now (add then straight to checkout) ---------- */
  var buyNowBtn = pdp.querySelector('[data-buynow]');
  if (buyNowBtn && form) {
    buyNowBtn.addEventListener('click', function () {
      var customBtn = pdp.querySelector('.t-fitseg button[data-mode="custom"].is-active');
      if (customBtn && atelier) {
        var missing = false;
        atelier.querySelectorAll('input[type=number]').forEach(function (inp) { if (!inp.value) missing = true; });
        if (missing) { window.ThayaToast && window.ThayaToast(pdp.dataset.fillMsg || 'Add your measurements first'); atelier.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
      }
      var extras = fbtExtras();
      var route = (window.THAYA && window.THAYA.routes && window.THAYA.routes.cart_add) || '/cart/add.js';
      var data = new FormData(form);
      var empties = []; data.forEach(function (v, k) { if (k.indexOf('properties[') === 0 && String(v).trim() === '') empties.push(k); });
      empties.forEach(function (k) { data.delete(k); });
      buyNowBtn.disabled = true;
      fetch(route, { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function () { if (extras.length) return fetch(route, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: extras }) }); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { buyNowBtn.disabled = false; });
    });
  }

  /* ---------- sticky ATC ---------- */
  var sticky = document.getElementById('thayaSticky');
  var buyRow = pdp.querySelector('.t-buy__row');
  if (sticky && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-show', !entries[0].isIntersecting && window.innerWidth <= 900);
    }, { rootMargin: '-90px 0px 0px 0px' }).observe(buyRow);
  }

  /* ---------- delivery estimate (business-day math) ---------- */
  var months = (window.THAYA && window.THAYA.rtl)
    ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
    : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addBiz(d, n) { var x = new Date(d), a = 0; while (a < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 5 && w !== 6) a++; } return x; }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return d.getDate() + ' ' + months[d.getMonth()]; }
  (function renderDelivery() {
    var now = new Date(), from = addDays(now, 10), to = addDays(now, 14);
    var r = pdp.querySelector('[data-deliv-range]'); if (r) r.textContent = fmt(from) + ' — ' + fmt(to);
    var t = pdp.querySelector('[data-deliv-today]'); if (t) t.textContent = fmt(now);
    var w = pdp.querySelector('[data-deliv-window]'); if (w) w.textContent = fmt(from) + '–' + fmt(to);
  })();

  /* ---------- modals ---------- */
  document.querySelectorAll('[data-open-modal]').forEach(function (b) {
    b.addEventListener('click', function () { var m = document.getElementById(b.dataset.openModal); if (m) m.hidden = false; });
  });
  document.querySelectorAll('[data-close-modal]').forEach(function (b) {
    b.addEventListener('click', function () { var m = b.closest('.t-modal'); if (m) m.hidden = true; });
  });
  document.querySelectorAll('.t-modal').forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m) m.hidden = true; });
  });

  /* ---------- fit finder ---------- */
  var ffGo = document.getElementById('thayaFfGo');
  if (ffGo) {
    ffGo.addEventListener('click', function () {
      var h = +document.getElementById('thayaFfH').value;
      if (!h || h < 120 || h > 210) { document.getElementById('thayaFfH').focus(); return; }
      // official THAYA size-by-height chart (cm -> size)
      var rec = h <= 152 ? 50 : h <= 157 ? 52 : h <= 162 ? 54 : h <= 167 ? 56 : h <= 172 ? 58 : 60;
      var rtl = window.THAYA && window.THAYA.rtl;
      document.getElementById('thayaFfSize').textContent = rec;
      document.getElementById('thayaFfResult').hidden = false;
      document.getElementById('thayaFfApply').onclick = function () {
        // pick the matching size button; if that size isn't available, snap to the closest one
        var sizeBtns = [].slice.call(pdp.querySelectorAll('.t-opt__btn')).filter(function (b) { return /^\d+$/.test((b.dataset.value || '').trim()); });
        var target = sizeBtns.filter(function (b) { return +b.dataset.value === rec; })[0];
        if (!target && sizeBtns.length) {
          target = sizeBtns.reduce(function (a, b) { return Math.abs(+b.dataset.value - rec) < Math.abs(+a.dataset.value - rec) ? b : a; });
        }
        if (target) target.click();
        document.getElementById('thayaFinder').hidden = true;
        var picked = target ? target.dataset.value : rec;
        window.ThayaToast && window.ThayaToast(rtl ? ('تم اختيار مقاس ' + picked) : ('Size ' + picked + ' selected'));
      };
    });
  }

  /* ---------- fit finder — XS–XL top-and-pants sets ---------- */
  /* Garment flat measurements in inches, from the THAYA linen-set spec sheet.
     Keep in sync with the table in the size guide modal (main-product.liquid). */
  var SET_CHART = [
    { size: 'XS', top: { bust: 34, waist: 32 }, pant: { waist: 26, hip: 35 } },
    { size: 'S',  top: { bust: 36, waist: 34 }, pant: { waist: 28, hip: 37 } },
    { size: 'M',  top: { bust: 38, waist: 36 }, pant: { waist: 30, hip: 38 } },
    { size: 'L',  top: { bust: 40, waist: 38 }, pant: { waist: 32, hip: 40 } },
    { size: 'XL', top: { bust: 42, waist: 40 }, pant: { waist: 34, hip: 42 } }
  ];
  var sfGo = document.getElementById('thayaSfGo');
  var sfModal = document.getElementById('thayaFinderSet');
  if (sfGo && sfModal) {
    /* Ease = how much room the garment should have over the body, in inches.
       Set in the theme editor (Product section) so the atelier can tune the fit
       without touching code. */
    var EASE = {
      bust: parseFloat(sfModal.dataset.easeBust) || 2,
      waist: parseFloat(sfModal.dataset.easeWaist) || 2,
      hip: parseFloat(sfModal.dataset.easeHip) || 1
    };
    var sfUnit = 'in';
    var unitWrap = document.querySelector('[data-set-unit]');
    if (unitWrap) {
      unitWrap.querySelectorAll('[data-sunit]').forEach(function (b) {
        b.addEventListener('click', function () {
          unitWrap.querySelectorAll('[data-sunit]').forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          sfUnit = b.dataset.sunit;
          document.querySelectorAll('.t-sunit-lbl').forEach(function (l) { l.textContent = sfUnit; });
        });
      });
    }

    var toIn = function (v) { return sfUnit === 'cm' ? v / 2.54 : v; };
    var num = function (id) { var v = parseFloat(document.getElementById(id).value); return isNaN(v) ? null : toIn(v); };
    // smallest size whose garment measurement clears body + ease; null if nothing fits
    var pick = function (get, body, ease) {
      if (body == null) return null;
      for (var i = 0; i < SET_CHART.length; i++) {
        if (get(SET_CHART[i]) >= body + ease) return i;
      }
      return SET_CHART.length - 1;
    };

    sfGo.addEventListener('click', function () {
      var bust = num('thayaSfBust'), waist = num('thayaSfWaist'), hip = num('thayaSfHip');
      if (bust == null && waist == null && hip == null) { document.getElementById('thayaSfBust').focus(); return; }

      var rtl = window.THAYA && window.THAYA.rtl;
      var iBust  = pick(function (r) { return r.top.bust; }, bust, EASE.bust);
      var iWaist = pick(function (r) { return r.top.waist; }, waist, EASE.waist);
      var iHip   = pick(function (r) { return r.pant.hip; }, hip, EASE.hip);

      // Bust drives the size — it's the least forgiving measurement on the top.
      // Waist and hip are a sanity check: if either wants a materially bigger
      // size we still recommend the bust size but say so, rather than silently
      // pushing everyone up a size or two.
      var base = iBust !== null ? iBust : (iHip !== null ? iHip : iWaist);
      if (base === null) return;

      var others = [iWaist, iHip].filter(function (v) { return v !== null; });
      var widest = others.length ? Math.max.apply(null, others) : base;
      var rec = SET_CHART[base].size;

      document.getElementById('thayaSfSize').textContent = rec;
      var why = document.getElementById('thayaSfWhy');
      if (why) {
        if (widest > base) {
          var upName = SET_CHART[Math.min(widest, SET_CHART.length - 1)].size;
          why.textContent = rtl
            ? ('قياس الخصر أو الأرداف أقرب لمقاس ' + upName + '. لو تفضّلين الإحساس الواسع اختاري ' + upName + '، أو راسلينا على واتساب.')
            : ('Your waist or hip sits closer to ' + upName + '. If you prefer a relaxed feel, take ' + upName + ' — or message us on WhatsApp.');
        } else {
          why.textContent = rtl ? 'الأنسب لقياساتك.' : 'The closest fit for your measurements.';
        }
      }
      document.getElementById('thayaSfResult').hidden = false;

      document.getElementById('thayaSfApply').onclick = function () {
        var btns = [].slice.call(pdp.querySelectorAll('.t-opt__btn'));
        var target = btns.filter(function (b) {
          return (b.dataset.value || '').trim().toUpperCase() === rec;
        })[0];
        if (target) target.click();
        document.getElementById('thayaFinderSet').hidden = true;
        window.ThayaToast && window.ThayaToast(
          target ? (rtl ? ('تم اختيار مقاس ' + rec) : ('Size ' + rec + ' selected'))
                 : (rtl ? ('مقاسك المقترح ' + rec) : ('Suggested size: ' + rec))
        );
      };
    });
  }
})();
